import { useMemo } from 'react';
import { useVdpPaymentTerms } from '~/context/vdp/UserVehicleContext';
import { useGetCkPromoFromDiscounts } from '~/hooks/common/creditKarmaPromo';
import useIsHighNetTrade from '~/hooks/vdp/useIsHighNetTrade';

export default function usePaymentSummary() {
  const {
    apr = 0,
    discounts = [],
    downPayment = 0,
    monthlyPayment = 0,
    downPaymentDetails: {
      additionalCashDown = 0,
      nonRefundableShippingFees = 0,
      totalCashDue = 0
    } = {},
    estimatedTaxesAndFees = 0,
    total: vehiclePrice = 0,
    totalDiscountAmount = 0,
    tradeDown = 0,
    term = 0
  } = useVdpPaymentTerms();
  const isHighNetTrade = useIsHighNetTrade();
  const tradeAmountToUse = isHighNetTrade ? 0 : tradeDown;
  const { creditKarmaPromoAmount = 0 } = useGetCkPromoFromDiscounts(discounts);
  const totalPrice =
    vehiclePrice +
    nonRefundableShippingFees +
    estimatedTaxesAndFees -
    totalDiscountAmount -
    tradeAmountToUse;

  return useMemo(() => {
    const credits = {
      creditKarmaPromoAmount,
      downPayment,
      totalDiscountAmount,
      tradeInCredit: tradeAmountToUse
    };

    const debits = {
      deliveryCharge: nonRefundableShippingFees,
      taxTitleReg: Math.round(estimatedTaxesAndFees),
      vehiclePrice: Math.round(vehiclePrice)
    };

    return {
      credits,
      debits,
      dueAtOrder: {
        additionalCashDown,
        nonRefundableShippingFees
      },
      financing: {
        apr,
        monthlyPayment,
        term
      },
      totals: {
        amountFinanced: Math.round(totalPrice - totalCashDue),
        subTotal: Math.round(totalPrice + tradeAmountToUse),
        totalCashDue,
        totalPrice: Math.round(totalPrice),
        totalPriceBeforeTrade: Math.round(totalPrice + tradeAmountToUse)
      }
    };
  }, [
    additionalCashDown,
    apr,
    creditKarmaPromoAmount,
    downPayment,
    estimatedTaxesAndFees,
    monthlyPayment,
    nonRefundableShippingFees,
    term,
    totalCashDue,
    totalDiscountAmount,
    totalPrice,
    tradeAmountToUse,
    vehiclePrice
  ]);
}
